
import { ControlElement } from '@jsonforms/core';
import { rendererProps, RendererProps, useJsonFormsEnumControl } from '@jsonforms/vue';
import { defineComponent } from 'vue';
import { useClearOnRefresh, useApiCallResource, useValidate, useErrors } from '../../util';

const controlRenderer = defineComponent({
  name: 'destination-ip-control-renderer',
  props: {
    ...rendererProps<ControlElement>(),
    itemLabel: {
      type: String,
    },
  },
  setup(props: RendererProps<ControlElement>) {
    const input = useJsonFormsEnumControl(props);
    useClearOnRefresh(input.control, input.handleChange);
    useValidate(input.control);
    const { subValResource } = useApiCallResource(input.control);
    const { listErrors } = useErrors(input.control);
    return { ...input, subValResource, listErrors };
  },
  data() {
    return {
      stringOptions: [],
      inputText: '',
      isTouched: false,
      localError: '',
    };
  },
  computed: {
    hasError(): boolean {
      if (this.control.uischema?.options?.hideError) {
        return false;
      }
      return !!(this.control.errors || this.listErrors.filter(error => error.source === this.control.path).length);
    },
    errorMessage(): string {
      return [this.control.errors, ...this.listErrors.filter(error => error.source === this.control.path).map(error => error.message)].filter(Boolean).join(', ');
    },
  },
  methods: {
    focusInput() {
      const applyFocus = () => {
        const selectComponent = this.$refs.selectRef as any;
        if (!selectComponent) {
          return;
        }

        selectComponent.hidePopup();
        selectComponent.focus();

        const nativeInput = selectComponent.$el?.querySelector('input');
        if (nativeInput) {
          nativeInput.focus();
        }
      };

      this.$nextTick(() => {
        applyFocus();
        setTimeout(applyFocus, 0);
        setTimeout(applyFocus, 50);
      });
    },

    normalizeIps(values: string[] = []): string[] {
      return values
        .flatMap((value) => value.split(','))
        .map((ip) => ip.trim())
        .filter(Boolean);
    },

    onBlur() {
      this.isTouched = true;
      this.commitInput();
      this.subValResource();
    },
    onEnterPress() {
      const selectComponent = this.$refs.selectRef as any;
      if (selectComponent) {
        selectComponent.hidePopup();
      }
      this.commitInput();
      this.subValResource();
    },
    onFocus() {
      // Optionally mark as touched on focus
    },
    createValue(val: any, done: any) {
      const trimmedVal = val.trim();
      if (trimmedVal.length > 0) {
        this.isTouched = true;
        const normalizedValues = this.normalizeIps([trimmedVal]);

        if (normalizedValues.length > 1) {
          const currentValue: string[] = this.control.data || [];
          const updated = [...currentValue, ...normalizedValues.filter((ip) => !currentValue.includes(ip))];
          // this.validateIps(updated);
          this.handleChange(this.control.path, updated.length ? updated : undefined);
          done();
        } else {
          done(normalizedValues[0]);
        }
        this.focusInput();
      }
    },
    changeInputText(value: string) {
      this.inputText = value;
    },
    // validateIps(value: string[] = []): void {
    //   this.localError = '';

    //   if (!value?.length) {
    //     this.localError = 'Field is required';
    //     return;
    //   }

    //   const ipRegex = new RegExp(this.ipPattern);
    //   const invalid = value?.find((ip) => !ipRegex.test(ip.trim()));
    //   if (invalid) {
    //     this.localError = `Invalid IP: ${invalid}`;
    //   }
    // },

    onChange(value: string[] | null) {
      this.isTouched = true;

      const cleanedValues = this.normalizeIps(value ?? []);

      // this.validateIps(cleanedValues);
      
      this.handleChange(this.control.path, cleanedValues.length ? cleanedValues : undefined);
      
      cleanedValues.forEach((val) => {
        if (!this.stringOptions.includes(val as never)) {
          this.stringOptions.push(val as never);
        }
      });
    },

    commitInput() {
      const currentValue: string[] = this.control.data || [];
      const trimmedInput = this.inputText.trim();

      if (trimmedInput) {
        const splitInput = this.normalizeIps([trimmedInput]);
        const updated = [...currentValue, ...splitInput.filter((ip) => !currentValue.includes(ip))];

        this.inputText = '';

        if (!updated.length || updated.length === currentValue.length) {
          this.focusInput();
          return;
        }

        // this.validateIps(updated);
        this.handleChange(this.control.path, updated);
        this.focusInput();
      }
    },
  },
});

export default controlRenderer;
